import Router from 'next/router';
import { notification } from 'antd';
const handleFetchError = (err: any, cb?: (...f: any) => void) => {
  if (process.browser) {
    notification.error({
      message: 'Oops!',
      description: err.error?.message || err.meta?.message || err.detail || err.message || err.toString()
    });
  }
  if (err.statusCode === 403 || err.statusCode === 401) {
    if (process.browser) {
      Router.replace('/forbidden');
    }
  }
  if (cb) cb(err);
  throw err;
};
export default handleFetchError;